class CountdownTimer extends HTMLElement {
  connectedCallback() {
    const { currentDateString, countdownDateString, daysString, hoursString, finishedString } = this.dataset;

    this.currentDate = this.getDateFromString(currentDateString);
    this.countdownDate = this.getDateFromString(countdownDateString);
    this.daysString = daysString;
    this.hoursString = hoursString;
    this.finishedString = finishedString;

    this.update = this.update.bind(this);
    this.update();
    this.interval = setInterval(this.update, 1000);
  }

  getDateFromString(str) {
    const parts = str.split('-');
    const date = new Date();

    date.setFullYear(parts[0]);
    date.setMonth(parts[1] - 1 || 0);
    date.setDate(parts[2] || 0);
    date.setHours(parts[3] || 0);
    date.setMinutes(parts[4] || 0);
    date.setSeconds(parts[5] || 0);

    return date;
  }

  update() {
    const diff = this.countdownDate - this.currentDate;

    if (diff <= 0) {
      this.innerHTML = this.finishedString;
      clearInterval(this.interval);

      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    this.innerHTML = (days > 0 ? this.daysString : this.hoursString)
      .replace('{{ days }}', days)
      .replace('{{ hours }}', hours)
      .replace('{{ minutes }}', minutes)
      .replace('{{ seconds }}', seconds);

    this.currentDate.setTime(this.currentDate.getTime() + 1000);
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
